import { FieldRegistryConfig } from "../../types";
import { DurationFieldControl } from "./DurationFieldControl/DurationFieldControl";
import { $t } from "../../../utils/intl";
import { fieldsText } from "../fields.text";
import { convertInputDuration } from "@smartsuite/fields-logic/lib/utils/duration";
import { defaultToReviewString } from "../review/reviewString.helpers";

export type DurationFieldValue = number;

export const durationFieldConfig: FieldRegistryConfig<DurationFieldValue> = {
  icon: "duration",
  control: (props) => (
    <DurationFieldControl {...props} placeholder={$t(fieldsText.durationPlaceholder)} />
  ),
  prefill: ({ value }) => {
    return convertInputDuration(value);
  },
  toReviewString: defaultToReviewString,
};
